import React from 'react';
import { TextField, Button, Box } from '@mui/material';

const ViewUnidad = React.memo(({ unidad, onClose }: any) => {
  return (
    <div>
      <form>
        <TextField label="Nombre" value={unidad.Un_Nombre} fullWidth disabled sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size="small" />
        <Box display="flex" justifyContent="flex-end">
          <Button onClick={onClose} variant="outlined" color="error" size="small">
            Cerrar
          </Button>
        </Box>
      </form>
    </div>
  );
});

export default ViewUnidad;
